import { useSelector } from 'react-redux'

import { useIsAuthed } from 'components/AuthShield'
import { useCurrentSeniorYear, useHighSchoolData, useStudentGraduationYear } from 'store/user/ts-hooks'

import {
  isAppStrategyEnabled,
  isCommonAppShutdownEnabled,
  isConfigureUpcomingApplicationCycleEnabled,
  isEnhancedManualRecAssignmentEnabled,
  isNLPCollegeSearchEnabled,
  isPlanParentAudienceEnabled,
  isSSNStorageEnabled,
  isUseUpcomingApplicationCycleEnabled,
} from '.'

export const useIsConfigureUpcomingApplicationCycleEnabled = () =>
  useSelector(isConfigureUpcomingApplicationCycleEnabled)
export const useIsSSNStorageEnabled = () => useSelector(isSSNStorageEnabled)

export const useIsEnhancedManualRecAssignmentEnabled = () => useSelector(isEnhancedManualRecAssignmentEnabled)
export const useIsCommonAppShutdownEnabled = () => useSelector(isCommonAppShutdownEnabled)

export const useIsAppStrategyEnabled = () => useSelector(isAppStrategyEnabled)

export const useIsUseUpcomingApplicationCycleEnabled = () => useSelector(isUseUpcomingApplicationCycleEnabled)

export const useIsPlanParentAudienceEnabled = () => useSelector(isPlanParentAudienceEnabled)

export const useIsStudentInterestShareEnabled = () => {
  const hs = useHighSchoolData()
  const currentSeniorYear = useCurrentSeniorYear()
  const studentGradYear = useStudentGraduationYear()
  // Display to sophomores+ unless hs setting is set otherwise
  const hsStartDisplayOffset = hs?.StudentInterestShareStartDisplayOffset ?? 2
  const displayToEligibleGradYear = studentGradYear <= currentSeniorYear + hsStartDisplayOffset
  // Can be removed after 2026 graduation
  const gradYearGTE27 = studentGradYear ? studentGradYear >= 2027 : false
  const featureEnabled = hs?.StudentInterestShareEnabled ?? true
  return displayToEligibleGradYear && gradYearGTE27 && featureEnabled
}

export const useIsNLPCollegeSearchEnabled = () => {
  const isAuthed = useIsAuthed()
  // NLPSearch is only available to authed users - for now
  return useSelector(isNLPCollegeSearchEnabled) && isAuthed
}
